<template>
    <v-container class="px-10" fluid style="height:100vh; background:#e7f0f7 ;">
        <div class="text-h6 mb-2" style="font-family:'Montserrat', sans-serif !important">
            UNIVERSITY
        </div>
        <searchAndFilterToolbar :btn_text="cl_text" @btn_action="dialog = true" :filButton="false"
            @search="searchFilter" />
        <v-table class="rounded-lg mt-4">
            <thead>
                <tr>
                    
                    <th class="text-left">
                        NAME
                    </th>

                    <th class="text-left">
                        ACTOINS
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item) in universityLis" :key="item.id">
                    <!-- <td>{{ item.id}}</td> -->
                    <td>{{ item.name }}</td>

                    <td>
                        <v-hover v-slot="{ isHovering, props }">
                            <v-avatar rounded size="small" v-bind="props" class="mr-1" @click="openEditDialog(item)"
                                :class="isHovering ? 'elevation-12' : 'elevation-2'" color="blue-darken-2"
                                style="cursor: pointer;">
                                <v-icon size="18" icon="mdi-pencil-outline"></v-icon>
                            </v-avatar>
                        </v-hover>
                        <v-hover v-slot="{ isHovering, props }">
                            <v-avatar rounded size="small" v-bind="props" class="mr-1" @click="openDeleteDialog(item)"
                                :class="isHovering ? 'elevation-12' : 'elevation-2'" color="#e9bc10"
                                style="cursor: pointer;">
                                <v-icon size="18" color="white" icon="mdi-trash-can-outline"></v-icon>
                            </v-avatar>
                        </v-hover>
                    </td>
                </tr>
            </tbody>
        </v-table>
        <paginationVue :length="universityTotalPage" @chanegePage="chanegePage" />
        <addBoroughVue :visible="dialog" @close="dialog = false" @save="addUniversity" :title="dialog_title" />
        <deleteWarnVue :visible="delete_dialog" @close="delete_dialog = false" :item="deleteValue"
            @delete="deleteUniversity" />
        <editBorough :visible="edit_dialog" @close="edit_dialog = false" @save="editUniversity"
            :title="edit_dialog_title" :item="edit_value" />
        <snackbarVue :visible="snackbar" :text="mssg" :button="false" :color="snackColor" @close="snackbar = false" />


    </v-container>
</template>

<script>
import searchAndFilterToolbar from '@/components/searchAndFilterToolbar.vue';
import { mapActions, mapState } from 'vuex'
import deleteWarnVue from '@/components/deleteWarn.vue';
import addBoroughVue from '@/components/borough/addBorough.vue'
import editBorough from '@/components/borough/editBorough.vue'
import paginationVue from '@/components/pagination.vue';
import snackbarVue from '@/components/snackbar.vue'

export default {
    name: 'university',
    components: {
        searchAndFilterToolbar,
        addBoroughVue,
        deleteWarnVue,
        editBorough,
        paginationVue,
        snackbarVue
    },
    data() {
        return {
            edit_dialog: false,
            edit_value: '',
            edit_id: '',
            snackbar: false,
            mssg: 'University Added successfully',
            snackColor: 'success',
            edit_dialog_title: 'Edit University',
            delete_dialog: false,
            cl_text: 'Add University',
            dialog: false,
            deleteValue: {},
            dialog_title: 'Add University',
            borough: [
                {
                    id: 1,
                    name: 'borough 1',
                },
                {
                    id: 2,
                    name: 'borough 2',
                }
            ]

        }
    },
    computed: {
        ...mapState('university', ['universityLis', 'universityTotalPage'])
    },
    methods: {
        ...mapActions('university', ['GET_UNIVERSITY_LIST', 'ADD_UNIVERSITY', 'EDIT_UNIVERSITY', 'DELETE_UNIVERSTY', 'SEARCH_FILTER_UNIVERSITY']),
        async addUniversity(item) {
            await this.ADD_UNIVERSITY(item).then(()=>{
                this.snackbar = true
            })
            this.dialog = false;
            await this.GET_UNIVERSITY_LIST();
        },
        openDeleteDialog(item) {
            this.delete_dialog = true;
            this.deleteValue = item
        },
        async deleteUniversity(item) {
            await this.DELETE_UNIVERSTY(item).then(()=>{
                this.mssg = 'University Deleted Successfully'
                this.snackbar = true;

            })
            this.delete_dialog = false;
            await this.GET_UNIVERSITY_LIST();
        },
        openEditDialog(item) {
            this.edit_value = item.name
            this.edit_id = item.id
            this.edit_dialog = true
        },
        async editUniversity(item) {
            item.id = this.edit_id
            // console.log(item)
            await this.EDIT_UNIVERSITY(item);
            this.edit_dialog = false;
            await this.GET_UNIVERSITY_LIST();

        },
        searchFilter(item) {
            const query = {
                size: 15,
                name: item
            }
            this.GET_UNIVERSITY_LIST(query)
        },
        chanegePage(item) {
            const query = {
                page: item,
                size: 15
            }
            this.GET_UNIVERSITY_LIST(query)
        }
    },
    mounted() {
        this.GET_UNIVERSITY_LIST();
    }
}
</script>

<style scoped>
tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05);
}

.v-table .v-table__wrapper>table>tbody>tr td {
    border-bottom: none;
    font-size: small;
    font-weight: 500;
}

.v-locale--is-ltr .v-table>.v-table__wrapper>table>thead>tr>th {
    border-bottom: none;
}

.v-table {
    font-family: Montserrat, sans-serif !important;
}

.v-locale--is-ltr .v-table>.v-table__wrapper>table>thead>tr>th {
    font-weight: 600 !important;
}
</style>